import {Component, Input, OnInit} from '@angular/core';
import {IWorldInfo} from "./i-world-info";
import {IRemoteGame} from "./i-remote-game";
import {IGenginePlayer} from "./i-gengine-player";
import {IGengineClient} from "./i-gengine-client";

@Component({
  selector: 'app-gengine-client',
  templateUrl: './gengine-client.component.html',
  styleUrls: ['./gengine-client.component.css']
})
export class GengineClientComponent implements OnInit {
  @Input() game: IRemoteGame;
  @Input() client : IGengineClient;

  hidden = false;
  loginStatus : string;
  connectStatus : string;
  gameStatus: string;
  worldsStatus: string;
  worldStatus: string;
  worlds: IWorldInfo[];
  newWorld: boolean;
  roomStatus: string;
  world: string = '??';
  player: IGenginePlayer;

  constructor() { }

  ngOnInit(): void {
    this.world = this.client.settings.world;
    this.scheduleAutoConnect();
  }

  scheduleAutoConnect(to = 200) {
    setTimeout(async () => {
      this.client.settings.load();
      if(this.client.settings.autoConnect) {
        await this.connect();
        await this.login(true);
        await this.joinGame(true);
        await this.joinWorld(true);
        if(!this.game.roomSelect) {
          await this.joinRoom();
        }
      }
    }, to);

  }
  toggleHidden()
  {
    this.hidden = !this.hidden;
  }


  onChange() {
    if(this.world === '') {
      this.newWorld = true;
    } else {
      this.client.settings.world = this.world;
    }
    this.client.settings.save();
    return true;
  }

  async connect() {
    try {
      this.newWorld = false;
      this.connectStatus = null;
      await this.client.connect();
      this.connectStatus = 'Connected ' + this.client.settings.serverUrl;
      this.client.disconnected.then(() => {
        this.connectStatus = "Disconnected";
        this.worldStatus = null;
        this.roomStatus = null;
        this.worldsStatus = null;
        this.player = null;
        this.loginStatus = null;
        this.scheduleAutoConnect(1000);
      });
    } catch(e) {
      console.error(e);
      this.connectStatus = "Error: " + e.message;
    }
  }

  async login(only = false) {
    try {
      this.loginStatus = null;
      this.player = await this.client.login();
      this.loginStatus = 'Logged in ' + this.client.settings.username;
      this.game.setPlayer(this.player);
      if(!only) {
        await this.joinGame();
      }
    } catch(e) {
      console.error(e);
      this.loginStatus = "Error: " + e.message;
    }
  }

  async joinGame(only = false) {
    try {
      this.gameStatus = null;
      await this.player.enterGame(this.game.name);
      this.gameStatus = 'Game entered';
      if(!only) {
        await this.getWorlds();
      }
    } catch(e) {
      console.error(e);
      this.gameStatus = "Error: " + e.message;
    }
  }

  async getWorlds() {
    try {
      this.worldsStatus = null;
      this.worlds = await this.player.getWorlds();
      if(this.worlds.length && !this.client.settings.world) {
        this.client.settings.world = this.world = this.worlds[0].name;
      }
      this.worldsStatus = 'Got groups';
    } catch(e) {
      console.error(e);
      this.worldsStatus = "Error: " + e.message;
    }
  }
  async joinWorld(only?: boolean): Promise<void> {
    try {
      this.worldStatus = null;
      await this.player.enterWorld(this.client.settings.world);
      this.worldStatus = 'Group entered ' + this.client.settings.world;
      if(!this.game.roomSelect && !only) {
        await this.joinRoom();
      }
    } catch(e) {
      console.error(e);
      this.worldStatus = "Error: " + e.message;
    }
  }

  async leaveWorld(): Promise<void> {
    try {
      await this.game.leaveGame();
      await this.player.leaveRoom();
      this.roomStatus = null;
      await this.player.leaveWorld();
    } catch(e) {
      console.error(e);
      this.worldStatus = "Error: " + e.message;
    }
    this.worldStatus = null;
    await this.getWorlds();
  }

  async joinRoom() {
    try {
      this.roomStatus = null;
      await this.game.joinRoom();
      this.roomStatus = 'Room entered ' + this.player.room.name;
    } catch(e) {
      console.error(e);
      this.roomStatus = "Error: " + e.message;
    }
  }

  async start() {
    await this.game.startGame();
  }

}
